export const SHOW_MESSAGE_BOX = 'SHOW_MESSAGE_BOX'
export const CLOSE_MESSAGE_BOX = 'CLOSE_MESSAGE_BOX'
export const SET_MESSAGE_BOX_PROPS = 'SET_MESSAGE_BOX_PROPS'
